export { default as ErrorImage } from './ErrorImage';
export { default as ErrorPage } from './ErrorPage';
export { default as ErrorPage404 } from './ErrorPage404';
